/**
 * Alert Component - Themed alert messages
 * Uses CSS modules with design tokens
 */

import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import styles from './Alert.module.css';

const Alert = ({
  children,
  variant = 'info', // 'info', 'success', 'warning', 'error'
  icon,
  className = ''
}) => {
  const getIcon = () => {
    if (icon) return icon;

    switch (variant) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'warning':
        return <AlertTriangle size={20} />;
      case 'error':
        return <XCircle size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  const alertClasses = [
    styles.alert,
    styles[variant],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={alertClasses} role="alert">
      <span className={styles.icon}>{getIcon()}</span>
      <div>{children}</div>
    </div>
  );
};

export default Alert;